const dtGenerator   = require ('../../../../../components/dt/dt-generator')
const dtHandler     = require ('../../../../../components/dt/dt-handler')
const dtSearch      = require ('../../../../../components/dt/dt-search')
const dtSearchHandler = require('../../../../../components/dt/dt-search-handler')
const transactionMenu  = require('./transaction-menu')
const transactionDialog = require('./transaction-dialog')
const dialog        = require('../../../../../components/dialog/dialog')
const snack         = require('../../../../../components/snack/snack')
const dbRequest     = require('../../../../../js-network/db-request')
const {organizeRow} = require('./transaction-dt-handler')
const {tableDetail} = require('./transaction-dt-handler')


/****************ELEMENTS*****************/
var htmlDt = {}
var HTMLwasSelected = false
var statusIds = []
var statusUpdating = false

function HTMLselect(){ 

      dtHandler.HTMLselect('transaction-dt', htmlDt, organizeRow, tableDetail)
      HTMLwasSelected  = true

      // htmlDt.sortBy = 'purchase.code'
      // htmlDt.sortDirection = "DESC"
            
}/**/

/****************ELEMENTS*****************/

export function start(detail){  //console.log('transaction-dt 5>', detail)
  
      if(!HTMLwasSelected) { HTMLselect() }
       
      obj[detail.act].start(detail)

}/**/

const obj = {
   
      //From fullcont connection    
      addRow:         { start: (detail)=>{  dtGenerator.addRow( detail, htmlDt  )            }},
      tableOptions:   { start: (detail)=>{  transactionMenu.start(detail, htmlDt, 'htmlFc')  }},
      trMenu:         { start: (detail)=>{  transactionMenu.start(detail, htmlDt, 'htmlFc')  }},
      statusDialog:   { start: (detail)=>{  statusDialog(detail)                            }},
      applyStatus:    { start: (detail)=>{  applyStatus(detail)                             }},
      updateRow:      { start: (detail)=>{  dtGenerator.updateRow(detail, htmlDt)            }},
      fullcontChanged: { start: (detail)=>{ fullcontChanged(detail)                        }},
      refresh:        { start: (detail)=>{ refresh(detail)                                }},

      //data table
      filter:         { start: (detail)=>{  dtSearch.filter(detail, htmlDt )          }},
      filterShowHide: { start: (detail)=>{  dtSearch.filterShowHide(detail, htmlDt )  }},
      loadMore:       { start: (detail)=>{  dtSearch.loadMore(detail, htmlDt )        }},
      searching:      { start: (detail)=>{  dtSearch.searching(detail, htmlDt )       }},
      select:         { start: (detail)=>{  dtSearch.select(detail, htmlDt, true )    }},
      th:             { start: (detail)=>{  dtSearch.th(detail, htmlDt )              }},
      trPrint:        { start: (detail)=>{  trPrint(detail)                           }},

}/**/

function trPrint (detail){ }//console.log(' trPrint>')   }

function refresh(detail, callback) {
    // Reinicia la paginacion y conserva los filtros y el orden seleccionados.
    dtSearchHandler.cleanDt(htmlDt)
    // El framework construye el POST desde detail.entity, no desde detail.dest.
    dtSearch.select({ ...detail, entity: htmlDt.entity, dest: htmlDt.dest }, htmlDt, true, callback)
}

function fullcontChanged(detail) {
    const record = detail.record
    const entity = record.transaction_type
    const recordId = String(record.id)

    // El ID del movimiento cambia al editar; entidad + registro identifica la operacion.
    if (detail.operation === 'deleteRow') {
        const row = [...htmlDt.dtBody.querySelectorAll('tr')].find((elem) =>
            elem.dataset.transactionEntity === entity && elem.dataset.transactionRecord === recordId)

        if (!row) {
            refresh({ dest: 'transaction' })
            return
        }

        const movementId = row.id.replace('transaction-tableRow-', '')
        dtGenerator.deleteRow({ dest: 'transaction', dbid: [movementId] })
        // Dejar terminar la animacion compartida antes de reconstruir filas y conteo.
        setTimeout(() => refresh({ dest: 'transaction' }), 900)
        return
    }

    refresh({ dest: 'transaction' }, (rows) => {
        const savedRow = rows.find((row) => row.entity === entity && String(row.entity_id) === recordId)
        if (!savedRow) return // La operacion puede haber quedado fuera del filtro o pagina.

        // El listado ya contiene la fila nueva o editada. updateRow aplica el mismo
        // tr-notice que addRow, sin duplicarla ni cambiar el orden del listado.
        dtGenerator.updateRow({ row: [savedRow] }, htmlDt)
        const row = document.getElementById(`transaction-tableRow-${savedRow.id}`)
        row.querySelector('input[type="checkbox"]').classList.add('checkAll')

        const fullcont = document.getElementById('transaction-fullcont')
        const type = fullcont?.querySelector('#transaction-type select')
        if (fullcont?.classList.contains('fullcont-show')
            && fullcont.getAttribute('data-dbid') === recordId && type?.value === entity) {
            dtHandler.highlightTr({ ev: { target: row }, dbid: savedRow.id })
        }
    })
}

async function statusDialog(detail) {
    if (statusUpdating || !Array.isArray(detail.dbid)) return

    statusIds = [...new Set(detail.dbid.map(String))]
    if (statusIds.length === 0 || statusIds.some((id) => !/^[1-9][0-9]*$/.test(id))) return

    statusUpdating = true
    try {
        const result = await dbRequest.start({ inf: {
            entity: 'transaction',
            operation: 'validate',
            ids: JSON.stringify(statusIds),
        } }, 'server/php/sql/updateTransationStatus.php')

        if (result.status !== 'ok' || result.restriction?.val !== 'ok') {
            transactionDialog.start({
                act: 'show', id: 'statusError', count: statusIds.length,
                rows: result.extrainfo?.invalid_rows,
                message: result.extrainfo?.message,
            })
            statusIds = []
            return
        }
        transactionDialog.start({ act: 'show', id: 'transactionStatus', count: statusIds.length, rows: result.data })
    } catch (error) {
        statusIds = []
        transactionDialog.start({ act: 'show', id: 'statusError' })
    } finally {
        statusUpdating = false
    }
}

async function applyStatus(detail) {
    const select = document.querySelector('#transaction-status select')
    const message = document.getElementById('transaction-status-message')
    if (statusUpdating || !select || statusIds.length === 0) return
    if (!['pending', 'cleared', 'canceled'].includes(select.value)) return

    const ids = [...statusIds]
    statusUpdating = true
    message.textContent = ''

    try {
        const result = await dbRequest.start({ inf: {
            entity: 'transaction',
            ids: JSON.stringify(ids),
            status: select.value,
        } }, 'server/php/sql/updateTransationStatus.php')

        if (result.status !== 'ok' || (result.restriction && result.restriction.val !== 'ok')) {
            if (result.extrainfo?.invalid_rows?.length > 0) {
                transactionDialog.start({
                    act: 'show', id: 'statusError', count: ids.length,
                    rows: result.extrainfo.invalid_rows,
                    message: result.extrainfo.message,
                })
                statusIds = []
                return
            }
            message.textContent = result.extrainfo?.message || 'The status could not be updated. Please try again.'
            return
        }

        statusIds = []
        if (document.querySelector('#transaction-status select') === select) {
            dialog.start({ act: 'hide' })
        }
        obj.refresh.start({ dest: 'transaction' })
        snack.start({ act: 'show', id: 'updateOk' })

    } catch (error) {
        message.textContent = 'The status could not be updated. Please try again.'
    } finally {
        statusUpdating = false
    }
}
